import { AfterViewInit, Component, OnInit, Input } from '@angular/core';
import { CaseFormsService } from 'src/app/modules/case-forms/case-forms.service';
import { SurgicalDiagnosisModel } from '../surgicalDiagnosis.model';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { StaticDataService } from 'src/app/services/static-data.service';
import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';
import { TdoUserConfigurationModel } from 'src/app/models/configuration/user/tdo-user-configuration.model';
import { UserService } from 'src/app/services/user.service';
import { Globals } from 'src/app/globals';
import { TdoDropdownModel } from 'src/app/tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import { SurgicalService } from 'src/app/services/form/surgical.service';
import { NotesService } from 'src/app/services/notes.service';
import { TdoNoteSaveModel, TdoNoteAssociatedObject } from 'src/app/main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { NoteCategoryEnum } from 'src/app/models/enum/note-category.enum';
import { NoteTypeEnum } from 'src/app/models/enum/note-type.enum';

@Component({
  standalone: false,
  selector: 'app-surgical-diagnosis',
  templateUrl: './surgical-diagnosis.component.html',
  styleUrls: ['./surgical-diagnosis.component.scss']
})
export class SurgicalDiagnosisComponent implements OnInit, AfterViewInit {
  @Input() caseWorkItemFormsId: string;
  toothName: string = ''  ;

  assistantPredicate: (data: TdoUserConfigurationModel) => string;
 // @Input() caseToothId: string;
 currentDiagnosis: SurgicalDiagnosisModel;
 enumSurgeryTypeEnums: EnumValidValueItemModel[] = [];
 assistants: TdoUserConfigurationModel[] = [];
 assistantDropdownModels: TdoDropdownModel[] = [];
  mtiProbings: any;
  isLoading: boolean = false;

  constructor(private readonly caseService: CaseFormsService,
    private readonly staticDataService: StaticDataService,
    private readonly userService: UserService,
    private readonly globals: Globals,
    private readonly surgicalService: SurgicalService,
    private readonly notesService: NotesService
  ) {}

  anatomicalConsiderations = [
    { value: 'isFloorOfNose', description: 'Floor of nose' },
    { value: 'isMaxSinus', description: 'Max Sinus' },
    { value: 'isMentalN', description: 'Mental n' },
    { value: 'isMandibN', description: 'Mandib n' },
    { value: 'isExtOblRidge', description: 'Ext obl ridge' },
    { value: 'isLackOfAttachGing', description: 'Lack of attach ging' },
    { value: 'isFrenumAttach', description: 'Frenum Attach' },
    { value: 'isShortRoots', description: 'Short Roots' },
    { value: 'isLingRootIncl', description: 'Ling root incl' },
    { value: 'isMuscleCTFlexibility', description: 'Muscle/C.T. Flexibility' },
    // TX-6982: was labelled "Frenum Attach", with "Tori" on an isZygoma field the model doesn't have
    // (the save dropped it, so the box unticked itself).
    { value: 'isFrenumAttachTori', description: 'Tori' },
    { value: 'isFrenumAttachToriB', description: 'B' },
    { value: 'isFrenumAttachToriL', description: 'L' }
    // Add more as needed
  ];

  treatmentComplexities = [
    { value: 'isPossibleToothFracture', description: 'Possible root fracture' },
    { value: 'isLaterRootLesion', description: 'Later root lesion' },
    { value: 'isRootPerforation', description: 'Root perforation' },
    { value: 'isFurcalPerforation', description: 'Furucal porforation' },
    { value: 'isSeparatedInstrument', description: 'Separated instrument' },
    { value: 'isCalcifiedCanalTC', description: 'Calcified canal' },
    { value: 'isLingualRoot', description: 'Lingual root' },
    { value: 'isComplicatedAnatomy', description: 'Complicated Anatomy' },
    { value: 'isImplantProximity', description: 'Implant proximity' },
    { value: 'isPerioEndo', description: 'Perio - Endo' },
    { value: 'isPerioTC', description: 'Perio' },  // TX-6982: was isPerio, a field the model doesn't have
    { value: 'isCompliance', description: 'Compliance' },
    { value: 'isExtResorption', description: 'Ext Resorption' },
    { value: 'isThruThru', description: 'Thru + Thru' },
    { value: 'isFutureImplantConsideration', description: 'Future Implant Considetarion' },
    { value: 'isFurcalInvolvement', description: 'Furcal Involvment' }


    // Add more as needed
  ];

  probableEtiology = [
    { value: 'isCSP', description: 'C+S+P' },
    { value: 'isPerforation', description: 'Perforation' },
    { value: 'isPriorFailingSurgery', description: 'Prior failing surgery' },
    { value: 'isCalcifiedCanalPE', description: 'Calcified Canal' },
    { value: 'isAnomalousAnatomy', description: 'Anonalous anatomy' },
    { value: 'isCombined', description: 'Combined' },
    { value: 'isPerioPE', description: 'Perio' },
    { value: 'isHistoryOfTrauma', description: 'History of trauma' },
    { value: 'isUnknownIndeterminate', description: 'Unknwon/Indeterminant' }

    // Add more as needed
  ];

  diffDiagnosis = [
    { value: 'isGranuloma', description: 'Granuloma' },
    { value: 'isCyst', description: 'Cyst' },
    { value: 'isNeoplasm', description: 'Neoplasm' },
    { value: 'isNonOdontogenic', description: 'Nonodontogenic' }
    // Add more as needed
  ];

  

  ngAfterViewInit(): void {}

  ngOnInit(): void {
    this.isLoading = true;

    // Fetch the surgical diagnosis form from the API
    if (this.globals.currentPatientId && this.caseWorkItemFormsId) {
      this.loadDiagnosisAndProbings(this.globals.currentPatientId, this.caseWorkItemFormsId).finally(() => {
        this.isLoading = false;
      });
    } else {
      this.currentDiagnosis = new SurgicalDiagnosisModel();
      this.isLoading = false;
    }

    this.assistantPredicate = (data: TdoUserConfigurationModel) => {
      return data.FirstName + ' ' + data.LastName;
    };

    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
          complete: () => {
              this.setupEnums();
          }
      });
  } else {
      this.setupEnums();
  }

    // Example: Load assistants (replace with real data source as needed)
    this.userService.getAssistantUsers(this.globals.TDOCID).subscribe((allUsers) => {
      this.assistants = allUsers;
      for (const model of this.assistants) {
        this.assistantDropdownModels.push(new TdoDropdownModel(model.FirstName + ' ' + model.LastName, model));
      }

    });
  }



  async setupEnums() {
    console.log('FinalReportComponent setupEnums');

    this.enumSurgeryTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumSurgeryType');


}


  getDate(date: Date) {
    if (date) {
      return new Date(date).toLocaleDateString();
    } else {
      return '';
    }
  }

  onCompleteDateFocus(event: FocusEvent) {
    if (!this.currentDiagnosis.thisDiagnosisCompleted) {
      this.currentDiagnosis.thisDiagnosisCompleted = new Date();
      this.saveSurgicalDiagnosis();
    }
  }
  saveSurgicalDiagnosis() {
    this.surgicalService.saveSurgicalDiagnosis(this.currentDiagnosis).subscribe(res => {
    if(res){
      this.currentDiagnosis = res;
    }
  });
}

  onCompleteDateChange(event: MatDatepickerInputEvent<any, any>) {
    this.currentDiagnosis.thisDiagnosisCompleted = event.value;
    this.saveSurgicalDiagnosis();
  }

  onCompleteDateInputFinish(event: any) {
    this.currentDiagnosis.thisDiagnosisCompleted = new Date(event);
    this.saveSurgicalDiagnosis();
  }
  get completedDateFormatted(): string {
    const date = this.currentDiagnosis?.thisDiagnosisCompleted;
    if (!date) return '';
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  }



  getAssistant() {
    if (this.currentDiagnosis && this.currentDiagnosis?.Assistant_UserID) {
      const usr = this.assistants.find(p => p?.UserID?.toLowerCase() === this.currentDiagnosis?.Assistant_UserID?.toLowerCase());
      if (usr) {
        return usr;
      }
    }
    return null;
  }


  onAssistantChange(event: any) {
    this.currentDiagnosis.Assistant_UserID = event?.value?.UserID;
    this.saveSurgicalDiagnosis();
  }

  onBooleanChange(event: any, key: string) {
    if (this.currentDiagnosis && key) {
      this.currentDiagnosis[key] = event.checked;
      this.saveSurgicalDiagnosis();
    }
  }

  // Surgery Type / Pre-Op Prognosis dropdowns. They used to only set the model, so the pick was
  // saved only if another control saved afterwards (TX-6982). tdo-enum-select also emits for the
  // value it was given while it initializes, so an unchanged value must not save: that would POST
  // on every open, and a late response could overwrite a newer edit.
  onEnumChange(item: any, key: string) {
    if (!this.currentDiagnosis || !key) return;
    const current = (this.currentDiagnosis[key] ?? '').toString().toLowerCase();
    const picked = (item?.ValidValueItemId ?? '').toString().toLowerCase();
    if (current === picked) return;
    this.currentDiagnosis[key] = item?.ValidValueItemId;
    this.saveSurgicalDiagnosis();
  }

  async loadDiagnosisAndProbings(patientId: string, caseWorkItemFormsId: string) {
    this.currentDiagnosis = await this.surgicalService.getSurgicalDiagnosisForm(patientId, caseWorkItemFormsId).toPromise();

    // Only proceed if currentDiagnosis and MTEToothID are available
    if (this.currentDiagnosis && this.currentDiagnosis.MTEToothID) {
      this.mtiProbings = await this.surgicalService.getMTIProbings(patientId, this.currentDiagnosis.MTEToothID).toPromise();
    } else {
      // Handle the case where the diagnosis or MTEToothID is missing
      this.mtiProbings = [];
      console.warn('No diagnosis or MTEToothID found, skipping probings fetch.');
    }
  }

  generateSurgicalDiagnosisNote(): string {
    // List of enum fields
    const enumFields = [
      'enumSurgeryTypeId',
      'enumSurgeryPreOpPrognosisId'
    ];
    let note = 'Surgical Diagnosis Summary\n';
    for (const key in this.currentDiagnosis) {
      if (!this.currentDiagnosis.hasOwnProperty(key)) continue;
      const value = this.currentDiagnosis[key];
      if (
        value &&
        typeof value !== 'function' &&
        key !== 'PatientID' &&
        key !== 'CaseWorkItemFormsId' &&
        key !== 'CaseWorkItemToothId' &&
        key !== 'MTEToothID'
      ) {
        let displayValue = value;
        if (enumFields.includes(key)) {
          const enumItem = this.staticDataService.getValidValueItemByItemId(value);
          if (enumItem && enumItem.ItemDisplayValue) {
            displayValue = enumItem.ItemDisplayValue;
          }
        }
        note += `${key}: ${displayValue}\n`;
      }
    }
    return note;
  }

  onSaveAsNote() {
    const noteText = this.generateSurgicalDiagnosisNote();
    const noteModel = new TdoNoteSaveModel();
    noteModel.text = noteText;
    noteModel.patientId = this.currentDiagnosis.PatientID || this.globals.currentPatientId;
    noteModel.categoryEnumIds = [NoteCategoryEnum.SurgicalDiagnosis];
    noteModel.typeEnumIds = [NoteTypeEnum.Case];
    const assoc = new TdoNoteAssociatedObject();
    assoc.objectId = this.currentDiagnosis.CaseWorkItemFormsId;
    assoc.parentObjectName = 'CaseWorkItemFormsId';
    noteModel.associatedObjects = [assoc];
    this.notesService.saveNote(noteModel).subscribe(res => {
      // Optionally refresh notes or show a message
    });
  }
}
